import { Component, ɵConsole } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { RouterModule } from '@angular/router';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    imports: [RouterModule]
})
export class AppComponent {

  constructor(private http: HttpClient) {

  }

  ngOnInit() {

    if(environment.production)
    {
      this.checkBuildVersion();

      setInterval(() => this.checkBuildVersion(), 60000);
    }

    if(window.location.hostname=='10.12.1.10' && environment.apiURL=='https://vmautapi.fundacoesnet.com.br'){
      alert('Atenção: Vc está usando a API de PRODUÇÃO');
    }

  }


  private checkBuildVersion(){

    let port = (window.location.port!='') ? ':'+window.location.port : '';
    let url = `${window.location.protocol}//${window.location.hostname}${port}/build-version.json?time=${new Date().getTime()}`;

    this.http
    .get(url)
    .subscribe(
      (res: any) => {
        if(environment.build != res.version){
          let conf = window.confirm("Existe uma nova versão do sistema, deseja atualizar a página agora para carregar a versão mais recente ?");

          if(conf){
            window.location.reload();
          }
        }

      },

    );

  }

}
